define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/_base/modules",
	"csi/def",
	"csi/def/Field",
	"csi/def/Relationship",
	"csi/form/Widget",
	"csi/xml",
	"csi/xml/Query",
	"Apparel/ProductAlternativeFormMixin"
], function(declare, lang, csi, modules, def, Field, Relationship, Widget, xml, Query, ProductAlternativeFormMixin) {

	return declare([Widget, ProductAlternativeFormMixin], {
		_resolveView: function() {
			// summary: add theme-PA and create-quote fields
			var style = this.defView.getSource().getParent();
			var theme = this.cacheView.getNode(style.Theme, true);
			this.insertField(lang.mixin(new Field(), {
				m_id: "ThemePA",
				m_onChange: "_onChangeThemePA",
				m_relationship: lang.mixin(new Relationship(), {
					m_url: theme.$URL,
					m_id: "ThemeProductAlternatives",
					m_query: new Query().Attr("Active", xml.OP_EQUALS, true)
				})
			}), 0);

			if (this.isCreateForm()) {
				// we're doing a create, not a copy
				this.insertField(lang.mixin(new Field(), {
					m_label: "CreateQuote",
					m_typeControl: def.FIELD_CHECKBOX
				}));
			}

			this.inherited(arguments);
		},

		_onChangeThemePA: function(/*csi.def.View*/defView, /*Field*/field, /*Any*/value) {
			// summary: update fields based on theme PA
			var themePA = (value == csi.EMPTY_URL) ? null : this.cacheView.getNode(value, true);
			this._updateFieldsFromThemePA(themePA);
		},

		_updateFieldsFromThemePA: function(/*Node*/themePA) {
			var spec = themePA ? this.cacheView.getNode(themePA.ThemePASpec, true) : null;
			this._updateCreateQuoteFieldFromSpecification(spec);
			this._updateNameFieldFromInputNode(themePA);
		}
	});
});